


































































/* istanbul ignore file */
import { defineComponent, PropType } from '@nuxtjs/composition-api';
import get from 'lodash/get';

import {
  SbBreak,
  SbHeading,
  SbHorizontalRule,
  SbListItem,
  SbOrderedList,
  SbParagraph,
  SbQuote,
  SbUnorderedList,
} from './components/blocks';
import { Block } from './constants';
import { DocumentNode } from './types';

export default defineComponent({
  name: 'RichTextDisplay',
  components: {
    SbParagraph,
    SbOrderedList,
    SbUnorderedList,
    SbHorizontalRule,
    SbBreak,
    SbListItem,
    SbHeading,
    SbQuote,
  },
  props: {
    content: {
      type: Object as PropType<DocumentNode>,
      default: () => ({}),
    },
  },
  data() {
    return {
      Block,
    };
  },
  methods: {
    isType(checkType: string, blockData: Record<string, unknown>) {
      return blockData.type === checkType || get(blockData, '_meta.type') === checkType;
    },
    getHeadingLevel(contentBlock: any) {
      return contentBlock?.attrs?.level || contentBlock?._meta?.attrs?.level;
    },
  },
});
